import React, { useEffect } from "react";
import "./Tax1.css";
import Taximage from "./SVGS/Icon-50001 4.png";
import { Link } from "react-router-dom";
import Account from "./SVGS/AccountingSVG";
import cardimage1 from "./SVGS/Group 48095656.png";
import cardimage2 from "./SVGS/healthy-brain.png";
import cardimage3 from "./SVGS/Group 48095673.png";
import lastsecimage from "./SVGS/Group 48095693.png";
import Assesmentimage from "./SVGS/Group 48095666.png";
import AOS from "aos"
import 'aos/dist/aos.css'

function Tax1() {
  
  useEffect(()=>{
    AOS.init({duration:2000})
    }, [])

  return (
    <div>
      <div className="contaniner-fluid main-tax-div1">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-12" >
              <h1 className="main-acc-text1">TAX Services</h1>

              <p className="main-acc-para1 mr-3">
                Self-assessment, Corporation tax return (known as CT600 form), A
                value-added tax (VAT) is collected on a product at every stage
                of its production
              </p>

              <div className="points-div mx-auto">
                <div className="d-flex">
                  <div className="">
                    <svg
                      width="21"
                      height="16"
                      viewBox="0 0 21 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M20.7071 8.70711C21.0976 8.31658 21.0976 7.68342 20.7071 7.2929L14.3431 0.928933C13.9526 0.538409 13.3195 0.538409 12.9289 0.928933C12.5384 1.31946 12.5384 1.95262 12.9289 2.34315L18.5858 8L12.9289 13.6569C12.5384 14.0474 12.5384 14.6805 12.9289 15.0711C13.3195 15.4616 13.9526 15.4616 14.3431 15.0711L20.7071 8.70711ZM-8.74228e-08 9L20 9L20 7L8.74228e-08 7L-8.74228e-08 9Z"
                        fill="#4E5896"
                      />
                    </svg>
                  </div>

                  <p className="main-acc-para-2">
                    Individual Tax Services{" "}
                    <br className="d-sm-none d-block"></br> - Self Assesment
                  </p>
                </div>

                <div className="d-flex">
                  <div className="">
                    <svg
                      width="21"
                      height="16"
                      viewBox="0 0 21 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M20.7071 8.70711C21.0976 8.31658 21.0976 7.68342 20.7071 7.2929L14.3431 0.928933C13.9526 0.538409 13.3195 0.538409 12.9289 0.928933C12.5384 1.31946 12.5384 1.95262 12.9289 2.34315L18.5858 8L12.9289 13.6569C12.5384 14.0474 12.5384 14.6805 12.9289 15.0711C13.3195 15.4616 13.9526 15.4616 14.3431 15.0711L20.7071 8.70711ZM-8.74228e-08 9L20 9L20 7L8.74228e-08 7L-8.74228e-08 9Z"
                        fill="#4E5896"
                      />
                    </svg>
                  </div>

                  <p className="main-acc-para-2"> Corporation Tax Return</p>
                </div>

                <div className="d-flex">
                  <div className="">
                    <svg
                      width="21"
                      height="16"
                      viewBox="0 0 21 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M20.7071 8.70711C21.0976 8.31658 21.0976 7.68342 20.7071 7.2929L14.3431 0.928933C13.9526 0.538409 13.3195 0.538409 12.9289 0.928933C12.5384 1.31946 12.5384 1.95262 12.9289 2.34315L18.5858 8L12.9289 13.6569C12.5384 14.0474 12.5384 14.6805 12.9289 15.0711C13.3195 15.4616 13.9526 15.4616 14.3431 15.0711L20.7071 8.70711ZM-8.74228e-08 9L20 9L20 7L8.74228e-08 7L-8.74228e-08 9Z"
                        fill="#4E5896"
                      />
                    </svg>
                  </div>

                  <p className="main-acc-para-2">Value Added Tax (VAT)</p>
                </div>
              </div>

              <div className="main-account-btn1 mx-auto mx-sm-0 d-sm-flex d-none">
                <Link to="/tax">Learn More </Link>
              </div>
            </div>

            <div className="col-lg-6 col-12 main-acc-img-div d-flex justify-content-center" >
              <img src={Taximage} className="taximage1" />
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid main-acc-div3">
        {/* <svg
          className="account-vector-1 d-sm-block d-none"
          width="61"
          height="201"
          viewBox="0 0 61 201"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M-25.5236 0.0623773C15.2168 1.51047 42.0611 37.8544 54.3897 76.877C66.3936 114.872 63.755 158.559 32.1837 182.719C-1.3977 208.417 -47.9657 206.104 -82.3746 181.535C-117.961 156.125 -138.079 112.331 -124.975 70.5016C-111.516 27.5381 -70.344 -1.53073 -25.5236 0.0623773Z"
            fill="#FFB532"
          />
        </svg> */}
        {/* <svg
          className="mobile-acc-vector1 d-sm-none d-block"
          width="34"
          height="150"
          viewBox="0 0 37 151"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M-27.665 0.0466188C2.78307 1.12888 22.8457 28.2912 32.0596 57.4554C41.031 85.8518 39.059 118.502 15.4636 136.558C-9.63408 155.764 -44.4375 154.036 -70.1536 135.674C-96.75 116.683 -111.786 83.9528 -101.992 52.6907C-91.9328 20.5811 -61.1624 -1.14402 -27.665 0.0466188Z"
            fill="#FFB532"
          />
        </svg> */}

        {/* <svg
          className="account-vector-2 d-sm-block d-none"
          width="61"
          height="197"
          viewBox="0 0 61 197"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M61.2817 5.87378C98.8246 -10.0136 138.503 11.5991 166.154 41.7685C193.077 71.1435 209.129 111.86 190.709 147.09C171.117 184.563 127.926 202.127 86.3613 194.382C43.3739 186.372 6.64746 155.166 0.866588 111.715C-5.07099 67.0856 19.979 23.3522 61.2817 5.87378Z"
            fill="#485CE1"
          />
        </svg>
        <svg
          className="mobile-acc-vector2 d-sm-none d-block"
          width="51"
          height="145"
          viewBox="0 0 51 145"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M45.2579 4.00533C72.9696 -7.72168 102.258 8.23139 122.668 30.5004C142.54 52.183 154.389 82.2373 140.793 108.242C126.331 135.902 94.4503 148.866 63.77 143.149C32.0396 137.237 4.93061 114.203 0.663561 82.13C-3.71916 49.1877 14.7711 16.9067 45.2579 4.00533Z"
            fill="#485CE1"
          />
        </svg>

        <svg
          className="account-vector-3 d-sm-block d-none"
          width="60"
          height="196"
          viewBox="0 0 60 196"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M-78.1714 5.58569C-40.6285 -10.3017 -0.949973 11.311 26.7008 41.4804C53.6236 70.8554 69.6758 111.572 51.2561 146.802C31.6636 184.275 -11.527 201.839 -53.0918 194.094C-96.0792 186.084 -132.806 154.878 -138.587 111.427C-144.524 66.7975 -119.474 23.0641 -78.1714 5.58569Z"
            fill="#485CE1"
          />
        </svg>

        <svg
          className="mobile-acc-vector3 d-sm-none d-block"
          width="60"
          height="196"
          viewBox="0 0 69 196"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M-69.1714 5.58594C-31.6285 -10.3015 8.05003 11.3113 35.7008 41.4806C62.6236 70.8556 78.6758 111.572 60.2561 146.802C40.6636 184.275 -2.52701 201.84 -44.0918 194.094C-87.0792 186.084 -123.806 154.878 -129.587 111.427C-135.524 66.7977 -110.474 23.0644 -69.1714 5.58594Z"
            fill="#485CE1"
          />
        </svg>

        <svg
          className="mobile-acc-vector4 d-sm-none d-block"
          width="54"
          height="196"
          viewBox="0 0 54 196"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M61.8286 5.58594C99.3715 -10.3015 139.05 11.3113 166.701 41.4806C193.624 70.8556 209.676 111.572 191.256 146.802C171.664 184.275 128.473 201.84 86.9082 194.094C43.9207 186.084 7.19434 154.878 1.41346 111.427C-4.52412 66.7977 20.5259 23.0644 61.8286 5.58594Z"
            fill="#FFB532"
          />
        </svg> */}

        <div className="container main-tax-div2">
          <h1 className="main-taxs-text1" id="individualTaxServices">
            Individual Tax Services - Self Assesment
          </h1>
          <p className="main-taxs-para2">
            Self-assessment is a system by which HMRC (HM Revenue and Customs)
            used to collect tax from people and businesses who are having income
            other than wages, pensions and savings as tax is already deducted
            from them.
          </p>
          <p className="main-taxs-para2">
            For this purpose, you need to register yourself as self-employed and
            Class 2 National Insurance with HMRC.
          </p>
          <p className="main-taxs-para2">
            After registering yourself you would get a UTR (Unique Tax
            Reference) number to continue with this process.
          </p>
          <p className="main-taxs-para2">
            Our professional team is aware of the process and provide you with
            the advice of lowering the tax at every step.
          </p>
          <p className="main-taxs-para2">
            Once you get in touch with us, an accountant will provide you with
            all the information and advise to save the tax. AJH Accountant is
            the team to make sure that the clients are on top of their taxes so
            they can make well-informed business and investment decisions as TAF
            has a motive about their clients that states{" "}
            <span>“GROW WITH US”.</span>{" "}
          </p>

          <h1 className="main-taxs-text3">
            We follow these steps in order to complete your tax return.
          </h1>

          <div className="points-div pl-sm-0 pr-sm-0 pl-4 pr-4">
            <div className="d-flex">
              <div className="">
                <svg
                  width="21"
                  height="16"
                  viewBox="0 0 21 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20.7071 8.70711C21.0976 8.31658 21.0976 7.68342 20.7071 7.2929L14.3431 0.928933C13.9526 0.538409 13.3195 0.538409 12.9289 0.928933C12.5384 1.31946 12.5384 1.95262 12.9289 2.34315L18.5858 8L12.9289 13.6569C12.5384 14.0474 12.5384 14.6805 12.9289 15.0711C13.3195 15.4616 13.9526 15.4616 14.3431 15.0711L20.7071 8.70711ZM-8.74228e-08 9L20 9L20 7L8.74228e-08 7L-8.74228e-08 9Z"
                    fill="#4E5896"
                  />
                </svg>
              </div>

              <p className="main-taxs-para-4">
                After your first call to our office, we sent you a form to fill
                where you provide us with your information
              </p>
            </div>

            <div className="d-flex mt-3">
              <div className="">
                <svg
                  width="21"
                  height="16"
                  viewBox="0 0 21 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20.7071 8.70711C21.0976 8.31658 21.0976 7.68342 20.7071 7.2929L14.3431 0.928933C13.9526 0.538409 13.3195 0.538409 12.9289 0.928933C12.5384 1.31946 12.5384 1.95262 12.9289 2.34315L18.5858 8L12.9289 13.6569C12.5384 14.0474 12.5384 14.6805 12.9289 15.0711C13.3195 15.4616 13.9526 15.4616 14.3431 15.0711L20.7071 8.70711ZM-8.74228e-08 9L20 9L20 7L8.74228e-08 7L-8.74228e-08 9Z"
                    fill="#4E5896"
                  />
                </svg>
              </div>

              <p className="main-taxs-para-4">
                An accountant is provided with this information to discuss
                everything with you in detail and advise you on your current
                scenario to save taxes.
              </p>
            </div>

            <div className="d-flex mt-3">
              <div className="">
                <svg
                  width="21"
                  height="16"
                  viewBox="0 0 21 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20.7071 8.70711C21.0976 8.31658 21.0976 7.68342 20.7071 7.2929L14.3431 0.928933C13.9526 0.538409 13.3195 0.538409 12.9289 0.928933C12.5384 1.31946 12.5384 1.95262 12.9289 2.34315L18.5858 8L12.9289 13.6569C12.5384 14.0474 12.5384 14.6805 12.9289 15.0711C13.3195 15.4616 13.9526 15.4616 14.3431 15.0711L20.7071 8.70711ZM-8.74228e-08 9L20 9L20 7L8.74228e-08 7L-8.74228e-08 9Z"
                    fill="#4E5896"
                  />
                </svg>
              </div>

              <p className="main-taxs-para-4">
                A checklist is then sent to you for collection of all the
                required documents from your side.
              </p>
            </div>

            <div className="d-flex mt-3">
              <div className="">
                <svg
                  width="21"
                  height="16"
                  viewBox="0 0 21 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20.7071 8.70711C21.0976 8.31658 21.0976 7.68342 20.7071 7.2929L14.3431 0.928933C13.9526 0.538409 13.3195 0.538409 12.9289 0.928933C12.5384 1.31946 12.5384 1.95262 12.9289 2.34315L18.5858 8L12.9289 13.6569C12.5384 14.0474 12.5384 14.6805 12.9289 15.0711C13.3195 15.4616 13.9526 15.4616 14.3431 15.0711L20.7071 8.70711ZM-8.74228e-08 9L20 9L20 7L8.74228e-08 7L-8.74228e-08 9Z"
                    fill="#4E5896"
                  />
                </svg>
              </div>

              <p className="main-taxs-para-4">
                We then use all the information provided by you to calculate the
                tax return and how much and when do you need to pay.
              </p>
            </div>

            <div className="d-flex mt-3">
              <div className="">
                <svg
                  width="21"
                  height="16"
                  viewBox="0 0 21 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20.7071 8.70711C21.0976 8.31658 21.0976 7.68342 20.7071 7.2929L14.3431 0.928933C13.9526 0.538409 13.3195 0.538409 12.9289 0.928933C12.5384 1.31946 12.5384 1.95262 12.9289 2.34315L18.5858 8L12.9289 13.6569C12.5384 14.0474 12.5384 14.6805 12.9289 15.0711C13.3195 15.4616 13.9526 15.4616 14.3431 15.0711L20.7071 8.70711ZM-8.74228e-08 9L20 9L20 7L8.74228e-08 7L-8.74228e-08 9Z"
                    fill="#4E5896"
                  />
                </svg>
              </div>

              <p className="main-taxs-para-4">
                We also advise you on the possibility of any further claims
                arising from your current scenario in the form and manner to
                HMRC.
              </p>
            </div>

            <div className="d-flex mt-3">
              <div className="">
                <svg
                  width="21"
                  height="16"
                  viewBox="0 0 21 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20.7071 8.70711C21.0976 8.31658 21.0976 7.68342 20.7071 7.2929L14.3431 0.928933C13.9526 0.538409 13.3195 0.538409 12.9289 0.928933C12.5384 1.31946 12.5384 1.95262 12.9289 2.34315L18.5858 8L12.9289 13.6569C12.5384 14.0474 12.5384 14.6805 12.9289 15.0711C13.3195 15.4616 13.9526 15.4616 14.3431 15.0711L20.7071 8.70711ZM-8.74228e-08 9L20 9L20 7L8.74228e-08 7L-8.74228e-08 9Z"
                    fill="#4E5896"
                  />
                </svg>
              </div>

              <p className="main-taxs-para-4">
                A draft tax return is then sent to you for your review and after
                your approval we submit your tax return to HMRC.
              </p>
            </div>

            <div className="d-flex mt-3">
              <div className="">
                <svg
                  width="21"
                  height="16"
                  viewBox="0 0 21 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20.7071 8.70711C21.0976 8.31658 21.0976 7.68342 20.7071 7.2929L14.3431 0.928933C13.9526 0.538409 13.3195 0.538409 12.9289 0.928933C12.5384 1.31946 12.5384 1.95262 12.9289 2.34315L18.5858 8L12.9289 13.6569C12.5384 14.0474 12.5384 14.6805 12.9289 15.0711C13.3195 15.4616 13.9526 15.4616 14.3431 15.0711L20.7071 8.70711ZM-8.74228e-08 9L20 9L20 7L8.74228e-08 7L-8.74228e-08 9Z"
                    fill="#4E5896"
                  />
                </svg>
              </div>

              <p className="main-taxs-para-4">
                Once the tax return is submitted we will check HMRC calculation
                and initiate repayment claims if you have overpaid.
              </p>
            </div>
          </div>

          <p className="main-taxs-para2 mt-4">
            Team TAF would be dealing with all the communication directly
            addressed by HMRC to us or forwarded to us by you.
          </p>

          <h1 className="main-taxs-text1" id="corporationTaxReturn">Corporation Tax Return</h1>
          <p className="main-taxs-para2">
            A Corporation tax return (also known as CT600 form) must be filed
            with HMRC by all Limited Companies within 12 months after the
            financial year.
          </p>
          <p className="main-taxs-para2">
            The first step is to notify HMRC that your company is subject to
            corporation tax. If your company must pay corporation tax, you must
            determine how much profit it makes each accounting period and how
            much tax is due.
          </p>
          <p className="main-taxs-para2">
            A 12-month accounting period is maximum. So even though the CT600
            isn’t due for another year, it must be paid within nine months and
            one day of the year’s end. Late returns or payments are subject to a
            penalty and possible interest.
          </p>
          <p className="main-taxs-para2">
            If in doubt, check the Companies House website to see when your
            company’s fiscal year ends. Corporation Tax, like many other taxes
            in the UK, is complex. A professional tax advisor can help you plan
            to minimise your tax liability.
          </p>
          <p className="main-taxs-para2">
            Individuals, sole traders, and partnerships are not required to pay
            Corporation Tax but must instead file self-assessment tax returns
            (also known as Personal Tax Return or SA302).
          </p>

          <h1 className="main-taxs-text1" id="valueAddedTax">Value Added Tax (VAT)</h1>
          <p className="main-taxs-para2">
            A value-added tax (VAT) is collected on a product at every stage of
            its production during which value is added to it, from its initial
            production to the point of sale.
          </p>
          <p className="main-taxs-para2">
            Businesses having the revenue over £85,000 are required to register
            for VAT to pay and charge VAT on the products they buy and sell.
            Businesses can also register for VAT voluntarily.
          </p>
          <p className="main-taxs-para2">
            Businesses charge VAT and they need to pay this charged VAT to HMRC
            depending on whenever they file their VAT return as some businesses
            do it monthly or quarterly.
          </p>

          <h1 className="main-taxs-text3">VAT RATES in UK.</h1>
          <p className="main-taxs-para2">
            {" "}
            <span> 20% </span>of VAT is applied on most of the goods and
            services.
          </p>
          <p className="main-taxs-para2">
            {" "}
            <span>5% </span>reduced rate is applied on some goods and services
            e.g children car seats and home energy
          </p>
          <p className="main-taxs-para2">
            {" "}
            <span>0% </span> VAT is applied on Zero-rated goods and services, eg
            most food and children’s clothes.
          </p>
          <p className="main-taxs-para2">
            VAT registered businesses are given a VAT registration certificate.
          </p>
          <p className="main-taxs-para2">
            When you contact us an accounts manager would provide you with all
            the information and advice which is required right from the
            registration of the business till the filing of it and would help
            you stay on top of the ever-changing VAT rules and regulations.
          </p>
          <p className="main-taxs-para2">
            If you can foresee that the business is about to hit the revenue of
            £85k, its better to start the process ahead of time to give you
            peace of mind. Your TAF team is there to help you on the way of all
            these processes and to help you GROW.
          </p>
        </div>
      </div>

      <div className="pl-sm-4 pl-0 pr-sm-4 pr-0">
        <div className="container-fluid home-div4">
          {/* <svg
            className="mobile-vector-4 d-sm-none d-block"
            width="70"
            height="168"
            viewBox="0 0 81 176"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M-42.2697 5.64827C-8.76728 -8.52926 26.6409 10.7574 51.3158 37.6798C75.341 63.8934 89.6656 100.228 73.2283 131.666C55.7445 165.106 17.2022 180.78 -19.8892 173.869C-58.2502 166.72 -91.0239 138.873 -96.1826 100.098C-101.481 60.2722 -79.1272 21.2456 -42.2697 5.64827Z"
              fill="#FFB532"
            />
          </svg> */}
          <h1 className="work-text1">
            How it <span>Works</span>
          </h1>

          <div className="container-fluid works-div3">
            <div className="row">
              <div className="col-sm-4 col-12 works-div2">
                <svg
                  width="120"
                  height="80"
                  viewBox="0 0 130 88"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M109.052 0.0136547C118.916 0.33065 125.415 8.28653 128.4 16.8288C131.306 25.1461 130.667 34.7095 123.023 39.9982C114.893 45.6236 103.619 45.1174 95.2883 39.739C86.6725 34.1766 81.8018 24.5899 84.9744 15.4332C88.233 6.02825 98.2009 -0.335086 109.052 0.0136547Z"
                    fill="#FFB532"
                  />
                  <path
                    d="M1.5 28V84.6138L13.0214 74.1611L13.4503 73.772H14.0293H98C108.217 73.772 116.5 65.4893 116.5 55.2721V28C116.5 17.7827 108.217 9.5 98 9.5H20C9.78274 9.5 1.5 17.7827 1.5 28Z"
                    stroke="#475CE3"
                    stroke-width="3"
                  />
                  <circle cx="36" cy="41" r="7" fill="#475CE3" />
                  <circle cx="59" cy="41" r="7" fill="#475CE3" />
                  <circle cx="82" cy="41" r="7" fill="#475CE3" />
                </svg>

                <h1 className="works-text2">
                  Answer a few <br></br>simple questions
                </h1>
              </div>

              <div className="col-sm-4 col-12 mt-sm-0 mt-5 works-div2">
                <svg
                  width="94"
                  height="94"
                  viewBox="0 0 102 102"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M79.0522 57.0137C88.9156 57.3306 95.4148 65.2865 98.3996 73.8288C101.306 82.1461 100.667 91.7095 93.0234 96.9982C84.8932 102.624 73.6188 102.117 65.2883 96.739C56.6725 91.1766 51.8018 81.5899 54.9744 72.4332C58.233 63.0282 68.2009 56.6649 79.0522 57.0137Z"
                    fill="#FFB532"
                  />
                  <path
                    d="M46.9669 61.744L30.0161 47.6205L29.2479 46.9805L28.6078 47.7486L24.2558 52.971L23.6156 53.7392L24.3838 54.3794L47.4494 73.603L49.0896 74.97V73.1787L78.2329 36.7463L78.8575 35.9654L78.0767 35.3407L72.7727 31.0975L71.992 30.4729L71.3672 31.2536L46.9669 61.744ZM1 51C1 37.7392 6.26784 25.0215 15.6447 15.6447C25.0215 6.26784 37.7392 1 51 1C64.2608 1 76.9785 6.26784 86.3553 15.6447C95.7322 25.0215 101 37.7392 101 51C101 64.2608 95.7322 76.9785 86.3553 86.3553C76.9785 95.7322 64.2608 101 51 101C37.7392 101 25.0215 95.7322 15.6447 86.3553C6.26784 76.9785 1 64.2608 1 51Z"
                    stroke="#475CE3"
                    stroke-width="2"
                  />
                  <path
                    d="M47 61.5L71.5 31L79 36.5L48.5 74.5L23.5 54L29 47L47 61.5Z"
                    fill="#475CE3"
                  />
                </svg>

                <h1 className="works-text2">
                  Get paired with a<br></br>tax return accountant
                </h1>
              </div>

              <div className="col-sm-4 col-12 mt-sm-0 mt-5 works-div2">
                <svg
                  width="128"
                  height="130"
                  viewBox="0 0 134 136"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M57.0522 64.0137C66.9156 64.3306 73.4148 72.2865 76.3996 80.8288C79.3058 89.1461 78.667 98.7095 71.0234 103.998C62.8932 109.624 51.6188 109.117 43.2883 103.739C34.6725 98.1766 29.8018 88.5899 32.9744 79.4332C36.233 70.0282 46.2009 63.6649 57.0522 64.0137Z"
                    fill="#FFB532"
                  />
                  <path
                    d="M85.5184 29.3845L84.2414 28.8753C77.431 26.1595 69.9839 25.804 63.1641 27.8513C56.3462 29.8981 50.5719 34.2203 46.8065 40.0769L85.5184 29.3845ZM85.5184 29.3845L86.1367 28.1566M85.5184 29.3845L86.1367 28.1566M86.1367 28.1566C86.4373 27.5598 86.865 27.036 87.3941 26.6186C87.9234 26.2011 88.5449 25.8975 89.2212 25.7312C89.8978 25.5649 90.6142 25.5397 91.3241 25.6619C92.0341 25.7841 92.7191 26.0505 93.3335 26.4454C93.9478 26.8402 94.4747 27.3527 94.8807 27.9479C95.2867 28.5429 95.5613 29.2051 95.691 29.8896C95.8206 30.5739 95.8026 31.2654 95.6426 31.9202C95.4827 32.5749 95.1838 33.1815 94.7657 33.7028L95.9358 34.6413M86.1367 28.1566L95.9358 34.6413M86.252 116.512L14.3431 70.2931C16.5713 69.5755 18.8613 68.3475 21.103 66.8556C24.7795 64.4087 28.5389 61.1062 32.0052 57.6566C38.9294 50.7655 44.8533 43.1157 46.8064 40.077L86.252 116.512ZM86.252 116.512C85.9793 114.187 86.1453 111.594 86.5715 108.935C87.2705 104.574 88.7134 99.7827 90.4118 95.1968C93.8048 86.0359 98.3035 77.4698 100.256 74.4313C108.148 62.1538 105.632 45.9581 94.9007 35.7269L95.9358 34.6413M86.252 116.512L95.9358 34.6413M48.8248 111.182C45.8253 111.762 42.6452 111.14 39.9925 109.435C37.3398 107.73 35.4538 105.096 34.7358 102.126C34.1411 99.667 34.3869 97.147 35.397 94.9436L55.0839 107.597C53.4991 109.431 51.3088 110.701 48.8248 111.182Z"
                    stroke="#475CE3"
                    stroke-width="3"
                  />
                  <path
                    d="M85.5 31C89.0259 32.8874 90.8863 34.2445 94 37L96 35.5V32L95.5 29.5L94.5 27L91.5 26L88 27L85.5 31Z"
                    fill="#475CE3"
                  />
                  <path
                    d="M55 107.5L36 95L34 101L37.5 108L43.5 111L48.5 111.5L52.5 110L55 107.5Z"
                    fill="#475CE3"
                  />
                </svg>

                <h1 className="works-text2">
                  We file your Self
                  <br></br>Assessment for you
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid home-div5">
        {/* <svg
          className="vector3 d-sm-block d-none"
          width="68"
          height="196"
          viewBox="0 0 68 196"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M61.8285 5.58569C99.3715 -10.3017 139.05 11.311 166.701 41.4804C193.624 70.8554 209.676 111.572 191.256 146.802C171.664 184.275 128.473 201.839 86.9082 194.094C43.9208 186.084 7.19434 154.878 1.41346 111.427C-4.52412 66.7975 20.5259 23.0641 61.8285 5.58569Z"
            fill="#FFB532"
          />
        </svg>
        <svg
          className="mobile-vector-5 d-block d-sm-none"
          width="52"
          height="187"
          viewBox="0 0 68 196"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M61.8285 5.58569C99.3715 -10.3017 139.05 11.311 166.701 41.4804C193.624 70.8554 209.676 111.572 191.256 146.802C171.664 184.275 128.473 201.839 86.9082 194.094C43.9208 186.084 7.19434 154.878 1.41346 111.427C-4.52412 66.7975 20.5259 23.0641 61.8285 5.58569Z"
            fill="#FFB532"
          />
        </svg> */}

        <div className="container main-div1 ">
          <div className="row">
            <div className="col-md-6 col-12 d-flex justify-content-center" >
              <img src={Assesmentimage} alt="" className="asses-img" />
            </div>
            <div className="col-md-6 col-12 asses-main-div1" >
              <h1 className="asses-text1">
                Let’s get your Self <br className="d-none d-md-block"></br>{" "}
                Assessment sorted <br className="d-none d-md-block"></br>today
              </h1>
              <p className="asses-para ">Taxes as they should be done</p>
              <div className=" asses-div1">
                <a href="tel:+44 01204 840303" className="asses-btn1 mx-auto mx-md-0">
                  <svg
                    className="call-btn-icon"
                    width="49"
                    height="49"
                    viewBox="0 0 49 49"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="24.5"
                      cy="24.5"
                      r="24.5"
                      fill="url(#paint0_linear_0_1)"
                    />
                    <path
                      d="M32.6877 29.3165L28.8086 25.7895C28.6252 25.6229 28.3842 25.534 28.1366 25.5417C27.8889 25.5493 27.6539 25.6529 27.4812 25.8306L25.1976 28.179C24.6479 28.0741 23.5429 27.7296 22.4054 26.595C21.2679 25.4565 20.9234 24.3486 20.8213 23.8028L23.1678 21.5182C23.3457 21.3456 23.4495 21.1106 23.4571 20.8629C23.4648 20.6151 23.3758 20.3741 23.2089 20.1909L19.6828 16.3127C19.5159 16.1289 19.2838 16.0174 19.036 16.0019C18.7881 15.9864 18.544 16.0681 18.3554 16.2297L16.2846 18.0056C16.1197 18.1712 16.0212 18.3915 16.0079 18.6249C15.9936 18.8635 15.7207 24.5146 20.1027 28.8986C23.9255 32.7204 28.7141 33 30.0329 33C30.2257 33 30.344 32.9943 30.3755 32.9924C30.6088 32.9793 30.8291 32.8804 30.9939 32.7147L32.7688 30.643C32.9311 30.455 33.0134 30.2111 32.9982 29.9632C32.9831 29.7154 32.8716 29.4833 32.6877 29.3165Z"
                      fill="black"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_0_1"
                        x1="24.5"
                        y1="0"
                        x2="24.5"
                        y2="49"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#FFB258" />
                        <stop offset="1" stop-color="#FFA131" />
                      </linearGradient>
                    </defs>
                  </svg>
                  <button className="btn ml-md-2 ml-4 asses-btn-text">
                    Call Us
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container home-div6">
        <svg
          className="vector4 "
          width="200"
          height="196"
          viewBox="0 0 200 196"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M61.8286 5.58569C99.3715 -10.3017 139.05 11.311 166.701 41.4804C193.624 70.8554 209.676 111.572 191.256 146.802C171.664 184.275 128.473 201.839 86.9082 194.094C43.9208 186.084 7.19434 154.878 1.41346 111.427C-4.52412 66.7975 20.5259 23.0641 61.8286 5.58569Z"
            fill="#485CDE"
          />
        </svg>

        <div className="row">
          <div className="col-lg-4 col-12 card1-div">
            <div className="card-1">
              <div className="card-div2">
                <div className="my-auto">
                  <img src={cardimage1} />
                </div>
                <h1 className="number-text1">1</h1>
              </div>
              <div>
                <h1 className="card-text-1">Painless tax returns</h1>
                <p className="card-para-1">
                  It’s a simple online process. Fast, efficient and a whole lot
                  less scary than doing it yourself.
                </p>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-12 mt-4 mt-lg-0">
            <div className="card-1">
              <div className="card-div2">
                <div className="my-auto">
                  <img src={cardimage2} />
                </div>

                <h1 className="number-text1">2</h1>
              </div>
              <div>
                <h1 className="card-text-1">Peace of mind</h1>
                <p className="card-para-1">
                  No more worrying about missing a rebate or making a mistake.
                  Get your return drafted by a real, accountant.
                </p>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-12 card3-div mt-4 mt-lg-0">
            <div className="card-1">
              <div className="card-div2">
                <div className="my-auto">
                  <img src={cardimage3} />
                </div>
                <h1 className="number-text1">3</h1>
              </div>
              <div>
                <h1 className="card-text-1">One Price</h1>
                <p className="card-para-1">
                  It doesn’t matter how complicated your situation is or how
                  much you earn. No matter what happens it’s £149
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid home-div7">
        <div className="container last-sec-div1">
          <div className="row">
            <div className="col-lg-6  col-12 last-sec-div2 my-auto" >
              <h1 className="last-text1">Just Start From</h1>
              <p className=" pr-md-5 pr-0 last-para1">
                No matter how complicated it gets or why you need to do a
                return, it’ll cost £149. That includes VAT, last-minute changes
                and all the support you may need.
              </p>

              <a href="tel:+44 01204 840303" className="asses-btn1 d-none d-lg-flex">
                <svg
                  className="call-btn-icon"
                  width="49"
                  height="49"
                  viewBox="0 0 49 49"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="24.5"
                    cy="24.5"
                    r="24.5"
                    fill="url(#paint0_linear_0_1)"
                  />
                  <path
                    d="M32.6877 29.3165L28.8086 25.7895C28.6252 25.6229 28.3842 25.534 28.1366 25.5417C27.8889 25.5493 27.6539 25.6529 27.4812 25.8306L25.1976 28.179C24.6479 28.0741 23.5429 27.7296 22.4054 26.595C21.2679 25.4565 20.9234 24.3486 20.8213 23.8028L23.1678 21.5182C23.3457 21.3456 23.4495 21.1106 23.4571 20.8629C23.4648 20.6151 23.3758 20.3741 23.2089 20.1909L19.6828 16.3127C19.5159 16.1289 19.2838 16.0174 19.036 16.0019C18.7881 15.9864 18.544 16.0681 18.3554 16.2297L16.2846 18.0056C16.1197 18.1712 16.0212 18.3915 16.0079 18.6249C15.9936 18.8635 15.7207 24.5146 20.1027 28.8986C23.9255 32.7204 28.7141 33 30.0329 33C30.2257 33 30.344 32.9943 30.3755 32.9924C30.6088 32.9793 30.8291 32.8804 30.9939 32.7147L32.7688 30.643C32.9311 30.455 33.0134 30.2111 32.9982 29.9632C32.9831 29.7154 32.8716 29.4833 32.6877 29.3165Z"
                    fill="black"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_0_1"
                      x1="24.5"
                      y1="0"
                      x2="24.5"
                      y2="49"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#FFB258" />
                      <stop offset="1" stop-color="#FFA131" />
                    </linearGradient>
                  </defs>
                </svg>
                <button className="btn ml-2 asses-btn-text">Call Us</button>
              </a>
            </div>
            <div className="col-lg-6 col-12 d-flex justify-content-center" >
              <img src={lastsecimage} className="lastsec-image"  />
            </div>
          </div>
        </div>
      </div>
      <a href="tel:+44 01204 840303" className="lastsecbtn mx-auto d-lg-none">
        <svg
          className="call-btn-icon1"
          width="49"
          height="49"
          viewBox="0 0 49 49"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="24.5" cy="24.5" r="24.5" fill="url(#paint0_linear_0_1)" />
          <path
            d="M32.6877 29.3165L28.8086 25.7895C28.6252 25.6229 28.3842 25.534 28.1366 25.5417C27.8889 25.5493 27.6539 25.6529 27.4812 25.8306L25.1976 28.179C24.6479 28.0741 23.5429 27.7296 22.4054 26.595C21.2679 25.4565 20.9234 24.3486 20.8213 23.8028L23.1678 21.5182C23.3457 21.3456 23.4495 21.1106 23.4571 20.8629C23.4648 20.6151 23.3758 20.3741 23.2089 20.1909L19.6828 16.3127C19.5159 16.1289 19.2838 16.0174 19.036 16.0019C18.7881 15.9864 18.544 16.0681 18.3554 16.2297L16.2846 18.0056C16.1197 18.1712 16.0212 18.3915 16.0079 18.6249C15.9936 18.8635 15.7207 24.5146 20.1027 28.8986C23.9255 32.7204 28.7141 33 30.0329 33C30.2257 33 30.344 32.9943 30.3755 32.9924C30.6088 32.9793 30.8291 32.8804 30.9939 32.7147L32.7688 30.643C32.9311 30.455 33.0134 30.2111 32.9982 29.9632C32.9831 29.7154 32.8716 29.4833 32.6877 29.3165Z"
            fill="black"
          />
          <defs>
            <linearGradient
              id="paint0_linear_0_1"
              x1="24.5"
              y1="0"
              x2="24.5"
              y2="49"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FFB258" />
              <stop offset="1" stop-color="#FFA131" />
            </linearGradient>
          </defs>
        </svg>
        <button className="btn ml-lg-2 ml-4 asses-btn-text">Call Us</button>
      </a>


    </div>
  );
}

export default Tax1;
